module.exports = __webpack_public_path__ + "img/be.985459b.svg";